import { generateProductsWithoutDev } from './quizResultsWithoutDev';
import { generateProductsWithDev } from './quizResultsWithDev';
import getContent from './dictionaryFetcher';
import {
  toolsFilterMapping,
  optionsToProductMapping,
  quizResultsCountryFilter,
  productFilterMHNS
} from './quizStaticMapping';
import { get, find, remove } from 'lodash';

const generateFinalProducts = options => {
  const { currentStep, steps, tools, productcompletion, app } = options;
  let products;
  if (currentStep === 2)
    products = generateProductsWithoutDev(steps, currentStep, tools);
  else products = generateProductsWithDev(steps, tools);
  return formattedProducts(products, productcompletion, app);
};

const isProductCompleted = (product, productcompletion) => {
  let filterRpsKey = get(productFilterMHNS, `${product}.rpsKey`),
    status = false;
  //If the product status is in RPS, get the rps attribute for that product
  if (filterRpsKey) {
    let profileAttributes = get(
        productcompletion,
        'rpsAttributes.profile_attributes',
        []
      ),
      productRpsObj = find(profileAttributes, { long_name: filterRpsKey });
    return get(productRpsObj, 'value') === 'Y';
  }
  //If the product status is in MNHS (merchanthubnodeserv)
  let mhnsProductArr = get(
      productcompletion,
      'mhnsResponse.data.appsByAttributes',
      []
    ),
    //Find the product in the mhnsProductArr array
    productObj = find(mhnsProductArr, {
      name: get(productFilterMHNS, `${product}`, '')
    }),
    //Get the last transaction date for the product
    lastTransactionDateOfProd = get(productObj, 'value');
  try {
    const dateObj = JSON.parse(lastTransactionDateOfProd);
    const date = get(dateObj, 'last_asstn_dt', '');
    if (date) {
      //Check whether the status is success and last transaction date (from above) is <= 1 year
      const yearAgoTime = new Date().setFullYear(new Date().getFullYear() - 1),
        transactionDate = new Date(date);
      status =
        get(productObj, 'status', '') === 'SUCCESS' &&
        transactionDate - yearAgoTime > 0;
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return status;
};

const formattedProducts = (finalProducts, productcompletion, app) => {
  validateExtraProducts(get(finalProducts, 'extras', []), app);
  let resultObj = {};
  Object.keys(finalProducts).forEach(type => {
    //For type extras products keep it an array
    if (type === 'extras') resultObj[type] = [];
    //For type developer and user products keep it an object
    else resultObj[type] = {};
    let productArr = finalProducts[type];
    productArr.forEach(item => {
      if (type === 'extras') {
        resultObj[type].push(item);
      } else {
        resultObj[type][item] = {
          isCollapsed: false,
          heading: getContent('quiz', `results.${item}.heading`),
          isProductCompleted: isProductCompleted(item, productcompletion)
        };
      }
    });
  });
  resultObj.extras.push('restart');
  return resultObj;
};

const shouldSkipToResults = (products, currentStep) =>
  currentStep === 2 && !products.includes('paymentsWebApp');

const validateProduct = (tools, product) =>
  get(tools[toolsFilterMapping[product]], 'active', false) ||
  product === 'ppme' ||
  optionsToProductMapping.extras.includes(product);

const validateExtraProducts = (extraProducts, app) => {
  let userCountry = get(app, 'legalCountry', '');
  remove(extraProducts, extraProduct => {
    let countryFilter = get(quizResultsCountryFilter, `${extraProduct}`, []);
    return countryFilter.includes(userCountry);
  });
};

export {
  generateFinalProducts,
  shouldSkipToResults,
  formattedProducts,
  validateProduct
};
